import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA. Appears once the visitor scrolls past the first
 * hero CTA (element with id="hero-cta") and shakes to draw attention.
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    const update = () => {
      if (!anchor) {
        setVisible(window.scrollY > 500);
        return;
      }
      const rect = anchor.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 px-3 pb-3 transition-[opacity,transform] duration-200 ease-out ${visible ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'}`} data-id="element-32" data-mp="1989l2ke5hk19">
      <div className="mx-auto w-full max-w-md rounded-2xl bg-ink/95 p-2 shadow-[0_-8px_28px_-10px_rgba(10,10,12,0.6)] ring-1 ring-white/10 backdrop-blur" data-id="element-33" data-mp="2f656n17foau5">
        <a href={CHECKOUT_URL} tabIndex={visible ? 0 : -1} className="animate-shake flex w-full items-center justify-center gap-2 rounded-xl bg-blood px-4 py-3.5 text-[13px] font-extrabold uppercase leading-tight tracking-wide text-white transition-colors duration-200 ease-out hover:bg-bloodDark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-sm" data-cta="floating" data-id="element-34" data-mp="26ap3ftksgjbw">
          <span aria-hidden="true" data-id="element-35" data-mp="3crj8rmbt9zu6">🔴</span>
          Get Hypertension Route — $27 USD
        </a>
        <p className="pb-0.5 pt-2 text-center text-[10px] font-medium uppercase tracking-[0.12em] text-white/55" data-id="element-36" data-mp="3hr5mdwvjxi3i">
          Instant access · Lifetime · 7-day guarantee
        </p>
      </div>
    </div>;
}